export { initializeFileTypeIcons } from './initializeFileTypeIcons';

export { FileTypeIconSize, IFileTypeIconOptions, ImageFileType, getFileTypeIconProps } from './getFileTypeIconProps';

export { FileIconType } from './FileIconType';

import './version';
